import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedDataService } from './shared-data.service';
import { CpMarketplaceApiService } from './cp-marketplace-api.service';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CpRolesEnum } from 'appRootPath/shared/global-meta-data';

@Injectable({ providedIn: 'root' })

export class CpAuthenticationService {

  private apiPath = environment.serverUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    private sharedDataService: SharedDataService,
    private cpApiService: CpMarketplaceApiService,
    private toastr: ToastrService
  ) { }

  storeLoginData(res: any) {
    if (res && res.token) {
      // store username and jwt token in session storage to keep user logged in between page refreshes
      this.sharedDataService.setCurrentUserToken(res.token, res.user_profile_name);
      res.is_bidding_enabled = false;
      this.sharedDataService.storeUserDataInLS(res);
      this.performRedirect();
      window.setTimeout(() => {
        this.sharedDataService.setLoginState(true);
      }, 100);
    }
  }

  logout(isApiLogout) {
    // remove user from session storage to log user out
    if (isApiLogout) {
      this.cpApiService.logout().subscribe((resp) => {
        this.sharedDataService.clearSessionStorage();
        this.router.navigate(['login']);
        this.sharedDataService.setLoginState(false);
      }, () => {
      });
    } else {
      this.sharedDataService.clearSessionStorage();
      this.router.navigate(['login']);
      this.sharedDataService.setLoginState(false);
    }
  }

  redirector(userSelectionData) {
    if (userSelectionData.iscadmin &&
      !userSelectionData.instrumentType &&
      !userSelectionData.divisionId &&
      !userSelectionData.roleId &&
      !userSelectionData.instrumentId) {
      this.router.navigate(['onboarding']);
    } else if (userSelectionData.roleType === CpRolesEnum.ISSUER) {
      this.router.navigate(['issuer/actionables/rd']);
    } else if (userSelectionData.roleType === CpRolesEnum.INVESTOR) {
      this.router.navigate(['investor/actionables/rd']);
    } else if (userSelectionData.roleType === CpRolesEnum.IPA) {
      this.router.navigate(['ipa']);
    } else {
      this.router.navigate(['login']);
    }
  }

  performRedirect() {
    if (!this.sharedDataService.getUserDataFromLS().auth_details.tnc_signed) {
      this.router.navigate(['terms-and-conditions']);
    } else {
      this.router.navigate(['/user-role/']);
    }
  }
}
